import { Link } from 'react-router-dom'
import { useLang } from '../../i18n/LanguageContext'
import './Footer.css'

function Footer() {
  const { t } = useLang()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-icon">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="8" fill="url(#gradient-footer)"/>
                  <path d="M12 28V12h4v12h10v4H12z" fill="white"/>
                  <defs>
                    <linearGradient id="gradient-footer" x1="0" y1="0" x2="40" y2="40">
                      <stop stopColor="#1e40af"/>
                      <stop offset="1" stopColor="#06b6d4"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <span>CommunityNord</span>
            </Link>
            <p className="footer-description">
              {t('footer.description')}
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.product')}</h4>
            <ul className="footer-links">
              <li><Link to="/features">{t('footer.features')}</Link></li>
              <li><Link to="/pricing">{t('footer.pricing')}</Link></li>
              <li><a href="/signup">{t('footer.getStarted')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.help')}</h4>
            <ul className="footer-links">
              <li><Link to="/contact">{t('footer.contactUs')}</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.legal')}</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} CommunityNord. {t('footer.copyright')}
            {' · '}
            <span className="footer-version">v{import.meta.env.VITE_BUILD_NUMBER || 'dev'}</span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
